// import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:520px;
margin-top:-200px;
`;


export const ContainerFluidX = styled.div`
// border:2px dashed red;
width:100%;
min-height:370px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657446957/re-brand/Vector_2_ykv9m0.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:left;
`;


export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
min-height: 396px;
`;

export const Cardde = styled.div
.attrs(() => ({
  className: '',
}))`
width:95%;
margin-left:auto;
margin-right:auto;
height: 246px;
background: #FFFFFF;
box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.05);
border-radius: 15px;
imag{
    height:80%;
    width:100%;
    background:red;
}
`;

export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
// width: 359px;
min-height: 38px;
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 40px;
line-height: 103%;
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;



export const DescText = styled.p
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 800;
font-size: 26px;
line-height: 103%;
/* identical to box height, or 27px */


color: #4A4A4A;

@media screen and (max-width: 425px) {
    width:auto !important;
}
`;